import { useState } from "react";
import "./Contact.css";

const services = [
  "Dental Implants",
  "Root Canal Treatment",
  "Cosmetic Dentistry",
  "Teeth Cleaning",
  "Dental Braces",
  "Oral Surgery",
  "General Checkup",
  "Other",
];

const timeSlots = [
  "9:00 AM","9:30 AM","10:00 AM","10:30 AM",
  "11:00 AM","11:30 AM","12:00 PM",
  "2:00 PM","2:30 PM","3:00 PM","3:30 PM",
  "4:00 PM","4:30 PM","5:00 PM",
  "6:00 PM","6:30 PM","7:00 PM","7:30 PM",
  "8:00 PM","8:30 PM",
];

const MONTHS = ["January","February","March","April","May","June",
                "July","August","September","October","November","December"];
const DAYS   = ["Su","Mo","Tu","We","Th","Fr","Sa"];

function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}
function getFirstDayOfMonth(year, month) {
  return new Date(year, month, 1).getDay();
}

export default function Contact() {
  const today = new Date();

  const [form, setForm] = useState({
  name: "",
  email: "",
  phone: "",
  service: "",
  reason: "",
  message: ""
});
  const [submitted, setSubmitted] = useState(false);

  const [calYear,  setCalYear]  = useState(today.getFullYear());
  const [calMonth, setCalMonth] = useState(today.getMonth());
  const [selDate,  setSelDate]  = useState(null);
  const [prefSlots, setPrefSlots] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value,
      ...(name === "service" && value !== "Other" ? { reason: "" } : {}),
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  const formattedDate = selDate
    ? `${MONTHS[selDate.month]} ${selDate.day}, ${selDate.year}`
    : "";

  const data = {
    name: form.name,
    email: form.email,
    phone: form.phone,
    service: form.service,
    reason: form.reason,
    message: form.message,
    date: formattedDate,
    slots: prefSlots
  };

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/appointment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    const result = await res.json();
    console.log("SERVER RESPONSE:", result);

    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setForm({
        name: "",
        email: "",
        phone: "",
        service: "",
        reason: "",
        message: ""
      });
    setSelDate(null);
    setPrefSlots([]);

  } catch (error) {
    console.error(error);
    alert("Error submitting appointment");
  }
};

  const prevMonth = () => {
    if (calMonth === 0) { setCalYear(y => y-1); setCalMonth(11); }
    else setCalMonth(m => m-1);
  };
  const nextMonth = () => {
    if (calMonth === 11) { setCalYear(y => y+1); setCalMonth(0); }
    else setCalMonth(m => m+1);
  };

  const isPast = (day) => {
    const d = new Date(calYear, calMonth, day); d.setHours(0,0,0,0);
    const t = new Date(); t.setHours(0,0,0,0);
    return d < t;
  };
  const isSunday  = (day) => false;
  const isToday   = (day) => day === today.getDate() && calMonth === today.getMonth() && calYear === today.getFullYear();
  const isSelected= (day) => selDate?.day === day && selDate?.month === calMonth && selDate?.year === calYear;

  const selectDay = (day) => {
    if (isPast(day)) return;
    setSelDate({ day, month: calMonth, year: calYear });
    setPrefSlots([]);
  };

  const toggleSlot = (slot) => {
    setPrefSlots(prev => {
      if (prev.includes(slot)) {
        return prev.filter(s => s !== slot);
      }

      if (prev.length >= 3) {
        return prev;
      }

      return [...prev, slot];
    });
  };

  const daysInMonth = getDaysInMonth(calYear, calMonth);
  const firstDay    = getFirstDayOfMonth(calYear, calMonth);
  const blanks      = Array(firstDay).fill(null);
  const dayNums     = Array.from({ length: daysInMonth }, (_, i) => i+1);

  const formattedDate = selDate
    ? `${MONTHS[selDate.month]} ${selDate.day}, ${selDate.year}`
    : null;

  const canSubmit = selDate && prefSlots.length === 3;

  return (
    <section className="contact" id="contact">
      <div className="contact-inner">

        {/* Left info */}
        <div className="contact-left">
          <span className="section-tag">Get In Touch</span>
          <h2 className="section-title">Book Your<br/>Appointment</h2>
          <p className="section-subtitle">
            Ready for a healthier smile? Reach out and our team will confirm your booking within 24 hours.
          </p>

          <div className="contact-info-list">
            {[
              { icon:"📍", label:"Our Location",   val:<>Ayya Koneru, Opposite Ganesh Temple, Subramanyam Peta, Babametta,<br/>Vizianagaram - 535002,<br/> Andhra Pradesh, India</> },
              { icon:"📞", label:"Phone Number",   val:<a href="tel:+919441683575">+91 94416 83575</a> },
              { icon:"✉️", label:"Email Address",  val:<a href="mailto:krishnadental588@gmail.com">krishnadental588@gmail.com</a> },
              { icon:"🕐", label:"Working Hours",  val:<>Mon – Sat: 9:00 AM – 8:00 PM<br/>Sunday: Closed</> },
            ].map(({ icon, label, val }) => (
              <div key={label} className="contact-info-item">
                <div className="ci-icon">{icon}</div>
                <div>
                  <div className="ci-label">{label}</div>
                  <div className="ci-value">{val}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="contact-map">
            <iframe
              title="Krishna Dental Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3792.165778390336!2d83.4188001!3d18.1101341!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3be54c5731d0d7%3A0x61d8731eef6eeaae!2sGanesh%20Temple!5e0!3m2!1sen!2sin!4v1775505789472!5m2!1sen!2sin"
              width="100%" height="200"
              style={{ border:0, borderRadius:"16px" }}
              allowFullScreen="" loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        {/* Right form */}
        <div className="contact-right">
          <div className="contact-form-card">
            {submitted ? (
              <div className="form-success">
                <div className="success-icon">✓</div>
                <h3>Appointment Requested!</h3>
                <p>We'll contact you within 24 hours to confirm your booking.</p>
                {formattedDate && <p className="success-date">📅 {formattedDate}</p>}
                {prefSlots.length > 0 && (
                  <div className="success-slots">
                    {prefSlots.map((s,i) => <span key={s} className="slot-pill">#{i+1} {s}</span>)}
                  </div>
                )}
              </div>
            ) : (
              <>
                <h3 className="form-title">Request an Appointment</h3>
                <p className="form-sub">Fill in your details and we'll get back to you shortly.</p>

                <form onSubmit={handleSubmit} className="contact-form">

                  <div className="form-row">
                    <div className="form-group">
                      <label>Full Name</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Your full name"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="you@example.com"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+91 XXXXX XXXXX"
                        value={form.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Service dropdown */}
                  <div className="form-group">
                    <label>Service Required</label>
                    <select name="service" value={form.service} onChange={handleChange} required>
                      <option value="">Select a service</option>
                      {services.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>

                  {/* Reason for visit — animated slide-in */}
                  {form.service === "Other" && (
                    <div className="form-group reason-slide-in">
                      <label>
                        Reason for Visit
                        <span className="reason-badge">Required</span>
                      </label>
                      <input
                        type="text" name="reason"
                        placeholder="Briefly describe your concern…"
                        value={form.reason} onChange={handleChange}
                        required autoFocus
                      />
                      <span className="reason-hint">💡 Helps our doctor prepare for your visit</span>
                    </div>
                  )}

                  {/* ── Calendar ── */}
                  <div className="form-group">
                    <label>
                      Preferred Date
                      {selDate && (
                        <span className="selected-date-badge">📅 {formattedDate}</span>
                      )}
                    </label>

                    <div className="calendar">
                      <div className="cal-header">
                        <button type="button" className="cal-nav" onClick={prevMonth}>‹</button>
                        <span className="cal-month-label">{MONTHS[calMonth]} {calYear}</span>
                        <button type="button" className="cal-nav" onClick={nextMonth}>›</button>
                      </div>

                      <div className="cal-grid cal-day-names">
                        {DAYS.map(d => (
                          <div key={d} className={`cal-day-name ${d==="Su"?"sunday-name":""}`}>{d}</div>
                        ))}
                      </div>

                      <div className="cal-grid">
                        {blanks.map((_,i) => <div key={`b${i}`} className="cal-cell blank"/>)}
                        {dayNums.map(day => {
                          const past    = isPast(day);
                          const sun     = isSunday(day);
                          const sel     = isSelected(day);
                          const tod     = isToday(day);
                          const unavail = past || sun;
                          return (
                            <button
                              key={day} type="button"
                              className={[
                                "cal-cell","cal-day",
                                sel     ? "cal-selected" : "",
                                tod&&!sel?"cal-today":"",
                                unavail ? "cal-unavail"  : "",
                              ].join(" ")}
                              onClick={() => selectDay(day)}
                              disabled={unavail}
                              title={sun?"Closed on Sundays":past?"Past date":""}
                            >
                              {day}
                              {tod && <span className="today-dot"/>}
                            </button>
                          );
                        })}
                      </div>

                      <div className="cal-legend">
                        <span><span className="leg-dot leg-today"/>Today</span>
                        <span><span className="leg-dot leg-sel"/>Selected</span>
                        <span><span className="leg-dot leg-off"/>Closed</span>
                      </div>
                    </div>
                  </div>

                  {/* ── Time slots — appear after date picked ── */}
                  {selDate && (
                    <div className="form-group slot-slide-in">
                      <label>
                        Preferred Time Slots
                        <span className="slot-count-badge">{prefSlots.length}/3 selected</span>
                      </label>
                      <p className="slot-sub">Pick up to 3 time preferences — we'll confirm the best available.</p>

                      <div className="time-slots-grid">
                        {timeSlots.map(slot => {
                          const picked = prefSlots.includes(slot);
                          const order  = picked ? prefSlots.indexOf(slot)+1 : null;
                          const maxed  = !picked && prefSlots.length >= 3;
                          return (
                            <button
                              key={slot} type="button"
                              className={[
                                "time-slot",
                                picked?"slot-picked":"",
                                maxed ?"slot-maxed":"",
                              ].join(" ")}
                              onClick={() => toggleSlot(slot)}
                              disabled={maxed}
                            >
                              {picked && <span className="slot-order">#{order}</span>}
                              {slot}
                            </button>
                          );
                        })}
                      </div>

                      {prefSlots.length > 0 && (
                        <div className="slot-summary">
                          <span className="slot-summary-label">Your preferences:</span>
                          {prefSlots.map((s,i) => (
                            <span key={s} className="slot-pill">#{i+1} {s}</span>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Message */}
                  <div className="form-group">
                    <label>Message (Optional)</label>
                    <textarea name="message" placeholder="Any additional notes or concerns…"
                      rows="3" value={form.message} onChange={handleChange}/>
                  </div>

                  <button type="submit" className={`btn-primary form-submit ${canSubmit?"":"submit-disabled"}`} disabled={!canSubmit}>
                    Confirm Appointment
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>

                  {!canSubmit && (
                    <p className="form-hint">
                      {!selDate
                        ? "📅 Please select a preferred date above"
                        : "🕐 Select three time slots according to your preference"}
                    </p>
                  )}

                </form>
              </>
            )}
          </div>
        </div>

      </div>
    </section>
  );
}
